// API Configuration for Development vs Production
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://virtualy-super-admin.vercel.app';

export { API_BASE_URL };